import { render, staticRenderFns } from "./EditorBlocks.vue?vue&type=template&id=d1e3399a&"
import script from "./EditorBlocks.vue?vue&type=script&lang=js&"
export * from "./EditorBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports